export enum OloSetTableNumberAs {
  TableNumber = 'table-number',
  OrderNumber = 'order-number',
}
